import { commandTemplateHead } from "./commandTemplateHead";
import { ticketTemplate, getImage } from "./ticketTemplate";
import { commandTemplate } from "./commandTemplate";

export const print = async (data:object | any, type:string) => {
  let template:any = '';
  if (type === 'commander') {
    template = commandTemplate(data);
  } else if (type === 'ticket') {
    await getImage(data?.companyId).then((res:any) => {
      template = ticketTemplate(data, res);
    });
  }

  const iframe = document.createElement("iframe");
  document.body.appendChild(iframe);

  iframe.style.display = "none";

  const { contentWindow } = iframe;

  
  if (contentWindow) {
    contentWindow.document.head.innerHTML = commandTemplateHead;
    contentWindow.document.body.innerHTML = template;

    contentWindow.close();
    setTimeout(() => {
      contentWindow.focus();
      contentWindow.print();
    }, 1200);
  }
};
